export type BookWeights = Record<string, number>;

export interface ConsensusBook {
  id: string;
  category: "sharp" | "retail";
}

export const CONSENSUS_BOOKS: ConsensusBook[] = [
  { id: "pinnacle", category: "sharp" },
  { id: "circa", category: "sharp" },
  { id: "novig", category: "sharp" },
  { id: "prophetx", category: "sharp" },
  { id: "fourcasters", category: "sharp" },
  { id: "sxbet", category: "sharp" },
  { id: "polymarket", category: "sharp" },
  { id: "kalshi", category: "sharp" },
  { id: "draftkings", category: "retail" },
  { id: "fanduel", category: "retail" },
  { id: "betmgm", category: "retail" },
  { id: "caesars", category: "retail" },
  { id: "hardrock", category: "retail" },
  { id: "fanatics", category: "retail" },
];

const CATEGORY_MAP = new Map(CONSENSUS_BOOKS.map(b => [b.id, b.category]));

export function getBookCategory(bookId: string): "sharp" | "retail" | "other" {
  return CATEGORY_MAP.get(bookId) ?? "other";
}

export interface WeightPreset {
  key: string;
  label: string;
  weights: BookWeights | null;
}

export const WEIGHT_PRESETS: WeightPreset[] = [
  { key: "default", label: "All Books (Default)", weights: null },
  { key: "sharpOnly", label: "Sharp Books Only", weights: { pinnacle: 1, circa: 1, novig: 1, prophetx: 1, fourcasters: 1, sxbet: 1, polymarket: 1, kalshi: 1 } },
  { key: "pinnacleOnly", label: "Pinnacle Only", weights: { pinnacle: 1 } },
];

export interface OfficialPreset {
  key: string;
  label: string;
  weights: BookWeights;
  requiredBooks: string[];
}

export const OFFICIAL_PRESETS: OfficialPreset[] = [
  {
    key: "matt",
    label: "Matt's Game Line Weights",
    weights: {
      novig: 7.5,
      fanduel: 1.1,
      kalshi: 1.1,
      draftkings: 1,
      prophetx: 1,
      polymarket: 3,
      draftkingspredictions: 1,
      pinnacle: 1,
      circa: 1,
      fourcx: 1,
      tailgate: 1,
      betonline: 1,
      caesars: 0.3,
      fanatics: 0.1,
      betmgm: 0.1,
    },
    requiredBooks: [],
  },
  {
    key: "matt-props",
    label: "Matt's Prop Weights",
    weights: {
      novig: 7,
      kalshi: 7,
      draftkings: 1.4,
      prophetx: 1.4,
      pinnacle: 1.4,
      fanduel: 1,
      caesars: 0.5,
      propbuilder: 0.5,
      rebet: 0.5,
      shuffle: 0.5,
      fliff: 0.5,
      sleeper: 0.5,
      hardrock: 0.1,
    },
    requiredBooks: [],
  },
  {
    key: "tj-cine-props",
    label: "TJ/Cine's Prop Weights",
    weights: {
      novig: 3,
      prophetx: 5,
      kalshi: 5,
      draftkings: 2,
      fanduel: 1,
    },
    requiredBooks: [],
  },
];

export function getOfficialPreset(key: string): OfficialPreset | undefined {
  return OFFICIAL_PRESETS.find((preset) => preset.key === key);
}
